import type { FC, ReactNode } from 'react'

import { COVE_FLOOR, COVE_KEY, VIGNETTE } from '@/constants/riffle-ui'

// The section's three light layers, viewport-anchored so a standing page
// scrolls through them exactly the way the pinned deck sits inside them.
// Paint order matches the stage: key light, floor glow, then the vignette
// over everything.

export const Stage: FC = (): ReactNode => {
    return (
        <>
            <div
                aria-hidden
                className='pointer-events-none fixed inset-0 z-0'
                style={{ background: COVE_KEY }}
            />

            <div
                aria-hidden
                className='pointer-events-none fixed inset-x-0 bottom-0 z-0 h-1/2'
                style={{ background: COVE_FLOOR }}
            />

            <div
                aria-hidden
                className='pointer-events-none fixed inset-0 z-20'
                style={{ background: VIGNETTE }}
            />
        </>
    )
}
